export const ACCOUNT_PAGE_STORE_ID = 'AccountPage'

export type AccountPageState = {
  readonly isLoading: boolean
  readonly emailAuthError: string
  readonly resetAuthError: string
}
